import { axiosInstance } from "./axiosInstance";

const getAllCourseByStatusApi = (
 data,
 query,
 status = 0,
 search = "",
 { year = null, semester = null } = {}
) => {
 const params = new URLSearchParams({
  type: query,
  status: String(status),
 });
 const trimmedSearch = String(search ?? "").trim();
 if (trimmedSearch) {
  params.set("search", trimmedSearch);
 }
 if (year != null && year !== "") {
  params.set("year", String(year));
 }
 const trimmedSemester = String(semester ?? "").trim();
 if (trimmedSemester) {
  params.set("semester", trimmedSemester);
 }
 return axiosInstance.post(`/Courses/GetAll?${params.toString()}`, data);
};

/** Tüm kursları tek istekte (sayfalama yok) */
const GetAllCalendarForAllRoles = () =>
 axiosInstance.post("/courses/GetAllCalendarForAllRoles");

const createCourseApi = (data) => axiosInstance.post("/courses/add", data);

const CreateCourseCalendar = (data) =>
 axiosInstance.post("/CourseCalendars/add", data);

const CreateAddOneDateApi = (body) =>
 axiosInstance.post("/CourseCalendars/AddOneDate", body);

const getDetailCourseApi = (id) => axiosInstance.get(`/courses/GetById/${id}`);

const updateCourseApi = (data) => axiosInstance.put("/courses/update", data);

const registerCourseApi = (data) =>
 axiosInstance.post("/CourseRegisters/Add", data);

const addCourseAdministrators = (data) =>
 axiosInstance.post("/CourseAdministrators/Add", data);

const deleteCourseAdministratorsApi = (id) =>
 axiosInstance.delete(`/CourseAdministrators/Delete/${id}`);

const administratorsGetAll = (data, userId) =>
 axiosInstance.post(
  userId != null && userId !== ""
   ? `/CourseAdministrators/GetAll?userId=${userId}`
   : "/CourseAdministrators/GetAll",
  data
 );

const CourseCalendarGetById = (id, data) =>
 axiosInstance.post(`/CourseCalendars/GetByCourseId?courseId=${id}`, data);

const DeleteCourseCalendarApi = (id) =>
 axiosInstance.delete(`/CourseCalendars/Delete/${id}`);

const deleteCourseSendEmailApi = (id) => axiosInstance.post(`/course/${id}`);

const DynamicCourseSearch = (data, query) =>
 axiosInstance.post(
  `/Courses/GetAllByDynamic?Page=${query.page}&PageSize=${query.pageSize}`,
  data
 );

/** Öğrenci canlı eğitim kayıt listesi (katalog Redis + doluluk DB) */
const getForStudentRegisterApi = ({
 branchId = null,
 dayOfWeek = null,
 page = 0,
 pageSize = 9,
} = {}) =>
 axiosInstance.post("/Courses/GetForStudentRegister", {
  branchId: branchId ?? null,
  dayOfWeek: dayOfWeek ?? null,
  page,
  pageSize,
 });

const getStudentLiveDashboardApi = ({ courseId, timeZone = "active", page = 0, pageSize = 10 } = {}) =>
 axiosInstance.post("/CourseCalendars/GetStudentLiveDashboard", {
  courseId,
  timeZone,
  pageRequest: { page, pageSize },
 });

export {
 getAllCourseByStatusApi,
 getDetailCourseApi,
 createCourseApi,
 updateCourseApi,
 deleteCourseSendEmailApi,
 addCourseAdministrators,
 GetAllCalendarForAllRoles,
 registerCourseApi,
 CreateCourseCalendar,
 administratorsGetAll,
 DynamicCourseSearch,
 getForStudentRegisterApi,
 getStudentLiveDashboardApi,
 CourseCalendarGetById,
 CreateAddOneDateApi,
 DeleteCourseCalendarApi,
 deleteCourseAdministratorsApi,
};
